jQuery( document ).ready( function() {

    jQuery(".dropdown_toggle").on("click", function(){
        if(!jQuery(this).siblings(".box_sub_menu").hasClass("hidden")){
            jQuery(this).siblings(".box_sub_menu").addClass("hidden");
        }
        else{
            jQuery(".box_sub_menu").each(function(){
                jQuery(this).addClass("hidden");
                jQuery(".menu_first .nav-link").removeClass("active");
            });
            jQuery(this).siblings(".box_sub_menu").removeClass("hidden");
            jQuery(this).addClass("active");
        }
    });


    jQuery(".link_sub_menu").hover(function(){
        var id = jQuery(this)[0].id;
        jQuery("#text-" + id).removeClass("hidden");
        },
        function(){
            jQuery(".box_text").addClass("hidden");
        });

    jQuery(".link_sub_menu").focus(function(){
        var id = jQuery(this)[0].id;
        jQuery("#text-" + id).removeClass("hidden");
        
    });

    jQuery(".link_sub_menu").focusout(function(){
        var id = jQuery(this)[0].id;
        jQuery(".box_text").addClass("hidden");
    });



    jQuery("#button-open-main").on("click", function(){
        jQuery(".main_desktop").addClass("mobile");
        jQuery("body").addClass("stop");
    });

    jQuery(".close_menu").on("click", function(){
        jQuery(".main_desktop").removeClass("mobile");
        jQuery("body").removeClass("stop");
    });

    jQuery("#share-new").on("click", function(){
        jQuery(".share_rrss").toggleClass("hidden");
    });


    jQuery(window).scroll(function() {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 130) {
          jQuery("#header-first").addClass("menu_show");

        } else {
            
            jQuery("#header-first").removeClass("menu_show");
        }
    });

});